(function () {
  'use strict';

  if (window.KarstStoreLocator && window.KarstStoreLocator.version) {
    window.KarstStoreLocator.initAll(document);
    return;
  }

  var CENTER = { lat: 47.92297066670341, lng: 9.287414637500024 };
  var INITIAL_ZOOM = 5;
  var ZOOM_THRESHOLD = 4;
  var MAP_SCRIPT_ID = 'karst-google-maps-js';
  var MAP_CALLBACK_NAME = '__karstStoreLocatorGoogleMapsReady';
  var MAP_STYLE = [
    { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
    {
      featureType: 'administrative.land_parcel',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#bdbdbd' }],
    },
    {
      featureType: 'administrative.province',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#787878' }, { visibility: 'on' }],
    },
    {
      featureType: 'administrative.country',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#575757' }],
    },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#757575' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#e5e5e5' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9e9e9e' }],
    },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#dadada' }] },
    {
      featureType: 'transit.station',
      elementType: 'geometry',
      stylers: [{ color: '#eeeeee' }],
    },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#e0e0e0' }] },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9e9e9e' }],
    },
  ];
  var MARKER_SVG = '<svg width="32" height="48" viewBox="0 0 32 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9993 0C7.17719 0 0 7.47323 0 16.6581C0 25.4994 14.5164 46.1557 15.1345 47.0304L15.7114 47.8478C15.7789 47.9438 15.8863 48 15.9993 48C16.1141 48 16.2208 47.9438 16.289 47.8478L16.8655 47.0304C17.4839 46.1557 32 25.4994 32 16.6581C32 7.47323 24.8216 0 15.9993 0ZM15.9993 10.6912C19.1603 10.6912 21.7307 13.3674 21.7307 16.6581C21.7307 19.9472 19.1602 22.6251 15.9993 22.6251C12.8402 22.6251 10.2679 19.9472 10.2679 16.6581C10.2679 13.3674 12.8401 10.6912 15.9993 10.6912Z" fill="#323232"/></svg>';
  var MARKER_SVG_MOBILE = '<svg width="24" height="36" viewBox="0 0 32 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9993 0C7.17719 0 0 7.47323 0 16.6581C0 25.4994 14.5164 46.1557 15.1345 47.0304L15.7114 47.8478C15.7789 47.9438 15.8863 48 15.9993 48C16.1141 48 16.2208 47.9438 16.289 47.8478L16.8655 47.0304C17.4839 46.1557 32 25.4994 32 16.6581C32 7.47323 24.8216 0 15.9993 0ZM15.9993 10.6912C19.1603 10.6912 21.7307 13.3674 21.7307 16.6581C21.7307 19.9472 19.1602 22.6251 15.9993 22.6251C12.8402 22.6251 10.2679 19.9472 10.2679 16.6581C10.2679 13.3674 12.8401 10.6912 15.9993 10.6912Z" fill="#323232"/></svg>';
  var SEARCH_EMPTY_COPY = 'No stores found in your searched location… yet!<br>But the good news is, you can still shop with us online anytime, anywhere!';
  var MAP_EMPTY_COPY = 'No stores found in this area. Try zooming out to discover the nearest Karst retailers – we could be just around the corner!';
  var mapsPromise = null;

  function initAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.karst-sl'), initSection);
  }

  function initSection(section) {
    if (!section || section.__karstStoreLocator) return;

    var mapEl = section.querySelector('[data-sl-map]');
    var searchInput = section.querySelector('[data-sl-search]');
    var storeCards = Array.prototype.slice.call(section.querySelectorAll('[data-sl-store]'));
    var caution = section.querySelector('[data-sl-caution]');
    var cautionText = caution ? caution.querySelector('p') : null;
    var empty = section.querySelector('[data-sl-empty]');
    var emptyText = empty ? empty.querySelector('p') : null;
    var items = storeCards.map(itemFromCard).filter(Boolean);
    var state = {
      boundsItems: items.filter(function (item) {
        return item.hasCoords;
      }),
      clusterer: null,
      googleListeners: [],
      infoWindow: null,
      items: items,
      map: null,
      mapReady: false,
      markers: [],
      query: '',
      zoom: INITIAL_ZOOM,
    };

    section.__karstStoreLocator = {
      destroy: function () {
        state.googleListeners.forEach(function (listener) {
          if (window.google && window.google.maps) {
            window.google.maps.event.removeListener(listener);
          }
        });
        if (state.clusterer && typeof state.clusterer.clearMarkers === 'function') {
          state.clusterer.clearMarkers();
        }
        state.markers.forEach(function (marker) {
          marker.setMap(null);
        });
        if (state.infoWindow) state.infoWindow.close();
        delete section.__karstStoreLocator;
      },
    };

    bindListInteractions(section, state);
    bindSearch(searchInput, state);
    updateList(section, state);

    if (!mapEl) return;

    var apiKey = (mapEl.getAttribute('data-api-key') || '').trim();
    if (!apiKey || !items.some(function (item) { return item.hasCoords; })) {
      mapEl.setAttribute('data-map-state', 'unavailable');
      return;
    }

    mapEl.setAttribute('data-map-state', 'loading');
    setPlaceholder(mapEl, 'Loading Maps...');

    loadGoogleMaps(apiKey)
      .then(function () {
        if (!document.documentElement.contains(section)) return;
        setupMap(section, state);
      })
      .catch(function () {
        mapEl.setAttribute('data-map-state', 'unavailable');
        setPlaceholder(mapEl, 'Map view');
        updateList(section, state);
      });
  }

  function itemFromCard(card, index) {
    var lat = parseFloat(card.getAttribute('data-lat') || '');
    var lng = parseFloat(card.getAttribute('data-lng') || '');
    var name = card.getAttribute('data-display-name') || text(card.querySelector('.karst-sl__store-name'));
    var address = card.getAttribute('data-display-address') || text(card.querySelector('.karst-sl__store-address'));
    var country = card.getAttribute('data-display-country') || text(card.querySelector('.karst-sl__country'));
    var website = card.getAttribute('data-website') || '';
    var link = card.querySelector('.karst-sl__link');

    if (!website && link) website = link.getAttribute('href') || '';

    return {
      address: address,
      card: card,
      country: country,
      hasCoords: Number.isFinite(lat) && Number.isFinite(lng),
      index: Number(card.getAttribute('data-sl-index') || index || 0),
      lat: lat,
      lng: lng,
      marker: null,
      name: name,
      searchText: [
        card.getAttribute('data-name') || name,
        card.getAttribute('data-address') || address,
        card.getAttribute('data-country') || country,
      ].join(' ').toLowerCase(),
      website: website,
    };
  }

  function bindSearch(searchInput, state) {
    if (!searchInput) return;
    searchInput.addEventListener('input', function () {
      state.query = searchInput.value.toLowerCase().trim();
      updateMarkers(state);
      updateList(searchInput.closest('.karst-sl'), state);
    });
  }

  function bindListInteractions(section, state) {
    state.items.forEach(function (item) {
      item.card.addEventListener('click', function (event) {
        if (event.target.closest('a')) return;
        openItem(item, state, true);
      });
      item.card.addEventListener('focusin', function () {
        openItem(item, state, true);
      });
    });
  }

  function setupMap(section, state) {
    var mapEl = section.querySelector('[data-sl-map]');
    var canvas = document.createElement('div');
    var isDesktop = window.matchMedia('(min-width: 1025px)').matches;
    var markerIcon = encodeMarker(isDesktop ? MARKER_SVG : MARKER_SVG_MOBILE);
    var mapOptions = {
      center: CENTER,
      disableDefaultUI: true,
      zoom: INITIAL_ZOOM,
      zoomControl: true,
    };
    var mapId = (mapEl.getAttribute('data-map-style') || '').trim();

    if (mapId) {
      mapOptions.mapId = mapId;
    } else {
      mapOptions.styles = MAP_STYLE;
    }

    canvas.className = 'karst-sl__map-canvas';
    canvas.style.height = '100%';
    canvas.style.width = '100%';
    mapEl.innerHTML = '';
    mapEl.appendChild(canvas);

    state.map = new window.google.maps.Map(canvas, mapOptions);
    state.infoWindow = new window.google.maps.InfoWindow();
    state.markers = state.items
      .filter(function (item) {
        return item.hasCoords;
      })
      .map(function (item) {
        var marker = new window.google.maps.Marker({
          icon: { url: markerIcon },
          optimized: true,
          position: { lat: item.lat, lng: item.lng },
          title: item.name,
        });
        marker.__karstItem = item;
        item.marker = marker;
        marker.addListener('click', function () {
          openItem(item, state, false);
        });
        return marker;
      });

    state.mapReady = true;
    mapEl.setAttribute('data-map-state', 'ready');

    setupClusterer(state);
    updateMarkers(state);

    state.googleListeners.push(
      state.map.addListener('idle', debounce(function () {
        updateBoundsItems(state);
        updateList(section, state);
      }, 300))
    );

    updateBoundsItems(state);
    updateList(section, state);
  }

  function setupClusterer(state) {
    var clusterNamespace = window.markerClusterer;
    if (!clusterNamespace || !clusterNamespace.MarkerClusterer) return;

    state.clusterer = new clusterNamespace.MarkerClusterer({
      algorithmOptions: { radius: 40 },
      map: state.map,
      markers: [],
      renderer: {
        render: function (cluster) {
          var count = cluster.count;
          var tier = count >= 100 ? 4 : count >= 50 ? 3 : count >= 25 ? 2 : count >= 10 ? 1 : 0;
          var size = [50, 56, 66, 78, 90][tier];
          var svg = window.btoa('<svg fill="#323232" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240"><circle cx="120" cy="120" opacity=".85" r="' + (90 + tier * 15) + '"/></svg>');

          return new window.google.maps.Marker({
            icon: {
              scaledSize: new window.google.maps.Size(size, size),
              url: 'data:image/svg+xml;base64,' + svg,
            },
            label: {
              color: '#fff',
              fontFamily: 'Monument Grotesk, sans-serif',
              fontSize: '14px',
              fontWeight: '500',
              text: String(count),
            },
            position: cluster.position,
            zIndex: 1000 + count,
          });
        },
      },
    });
  }

  function updateMarkers(state) {
    if (!state.mapReady) return;

    var visibleItems = state.query
      ? state.items.filter(function (item) {
          return item.hasCoords && item.searchText.indexOf(state.query) !== -1;
        })
      : state.items.filter(function (item) {
          return item.hasCoords;
        });
    var visibleMarkers = visibleItems.map(function (item) { return item.marker; }).filter(Boolean);

    if (state.clusterer) {
      state.clusterer.clearMarkers(true);
      state.markers.forEach(function (marker) {
        marker.setMap(null);
      });
      state.clusterer.addMarkers(visibleMarkers, true);
      state.clusterer.render();
    } else {
      state.markers.forEach(function (marker) {
        marker.setMap(visibleMarkers.indexOf(marker) !== -1 ? state.map : null);
      });
    }
  }

  function updateBoundsItems(state) {
    if (!state.mapReady || !state.map) return;

    var bounds = state.map.getBounds();
    state.zoom = state.map.getZoom() || INITIAL_ZOOM;

    if (!bounds) return;

    state.boundsItems = state.items.filter(function (item) {
      return item.hasCoords && bounds.contains(new window.google.maps.LatLng(item.lat, item.lng));
    });
  }

  function updateList(section, state) {
    var searchMatches = state.query
      ? state.items.filter(function (item) {
          return item.searchText.indexOf(state.query) !== -1;
        })
      : state.items;
    var mapMatches = state.mapReady ? state.boundsItems : state.items;
    var shownItems;

    if (state.query) {
      shownItems = searchMatches;
    } else if (state.mapReady && state.zoom <= ZOOM_THRESHOLD) {
      shownItems = [];
    } else {
      shownItems = mapMatches;
    }

    state.items.forEach(function (item) {
      item.card.setAttribute('data-hidden', shownItems.indexOf(item) === -1 ? 'true' : 'false');
    });

    renderMessages(section, state, searchMatches, mapMatches);
  }

  function renderMessages(section, state, searchMatches, mapMatches) {
    var caution = section.querySelector('[data-sl-caution]');
    var cautionText = caution ? caution.querySelector('p') : null;
    var empty = section.querySelector('[data-sl-empty]');
    var emptyText = empty ? empty.querySelector('p') : null;

    if (state.query) {
      if (caution) caution.hidden = true;
      if (empty) empty.hidden = searchMatches.length !== 0;
      if (emptyText) emptyText.innerHTML = SEARCH_EMPTY_COPY;
      return;
    }

    if (!state.mapReady) {
      if (caution) caution.hidden = true;
      if (empty) empty.hidden = true;
      return;
    }

    if (mapMatches.length === 0) {
      if (caution) caution.hidden = true;
      if (empty) empty.hidden = false;
      if (emptyText) emptyText.innerHTML = MAP_EMPTY_COPY;
      return;
    }

    if (state.zoom <= ZOOM_THRESHOLD) {
      if (caution) caution.hidden = false;
      if (empty) empty.hidden = true;
      if (cautionText) {
        cautionText.innerHTML = 'Showing <b data-sl-count>' + mapMatches.length + '</b> Stores.<br>Zoom in, enter a location above, or click on a marker for more detail.';
      }
      return;
    }

    if (caution) caution.hidden = true;
    if (empty) empty.hidden = true;
  }

  function openItem(item, state, focusMap) {
    if (!state.mapReady || !item || !item.hasCoords || !item.marker) return;

    if (focusMap) {
      state.map.panTo({ lat: item.lat, lng: item.lng });
      if ((state.map.getZoom() || 0) < 10) state.map.setZoom(10);
    }

    state.infoWindow.setContent(infoWindowHtml(item));
    state.infoWindow.open({
      anchor: item.marker,
      map: state.map,
      shouldFocus: false,
    });

    window.google.maps.event.addListenerOnce(state.infoWindow, 'domready', function () {
      var close = state.map.getDiv().querySelector('[data-sl-info-close]');
      if (close) {
        close.addEventListener('click', function () {
          state.infoWindow.close();
        });
      }
    });
  }

  function infoWindowHtml(item) {
    var website = normalizeWebsite(item.website);
    var websiteDisplay = website ? displayWebsite(website) : '';
    var directions = 'https://www.google.com/maps?q=' + encodeURIComponent(item.name + ' ' + item.address);

    return [
      '<div class="karst-sl__info">',
      '<button class="karst-sl__info-close" type="button" aria-label="Close info pop-up" data-sl-info-close><svg aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.2"/></svg></button>',
      '<span class="karst-sl__info-country">' + escapeHtml(item.country) + '</span>',
      '<div class="karst-sl__info-list">',
      '<h4 class="karst-sl__info-name">' + escapeHtml(item.name) + '</h4>',
      '<span>' + escapeHtml(item.address) + '</span>',
      website ? '<a class="karst-sl__info-link" href="' + escapeAttribute(website) + '" target="_blank" rel="noopener noreferrer">' + escapeHtml(websiteDisplay) + '</a>' : '',
      '</div>',
      '<a class="karst-sl__info-directions" href="' + escapeAttribute(directions) + '" target="_blank" rel="noopener noreferrer"><span>Get directions</span><svg class="karst-sl__info-arrow" aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 72 71" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66.2451 34.1349L32.7975 2.64576L34.6204 0.709445L71.5802 35.505L38.8314 70.2906L36.7741 68.3537L66.4109 36.8736L1.95456 36.8644L1.78882 34.1257L66.2451 34.1349Z" fill="currentColor"/></svg></a>',
      '</div>',
    ].join('');
  }

  function loadGoogleMaps(apiKey) {
    if (window.google && window.google.maps && window.google.maps.Map) {
      return Promise.resolve(window.google.maps);
    }
    if (mapsPromise) return mapsPromise;

    mapsPromise = new Promise(function (resolve, reject) {
      var existing = document.getElementById(MAP_SCRIPT_ID);
      var previousCallback = window[MAP_CALLBACK_NAME];
      var resolved = false;

      function resolveMaps() {
        if (resolved || !window.google || !window.google.maps || !window.google.maps.Map) return;
        resolved = true;
        resolve(window.google.maps);
      }

      window[MAP_CALLBACK_NAME] = function () {
        resolveMaps();
        if (typeof previousCallback === 'function') previousCallback();
      };

      if (existing) {
        existing.addEventListener('load', function () {
          resolveMaps();
        });
        existing.addEventListener('error', function (error) {
          if (!resolved) reject(error);
        });
        return;
      }

      var script = document.createElement('script');
      script.id = MAP_SCRIPT_ID;
      script.async = true;
      script.src = 'https://maps.googleapis.com/maps/api/js?key='
        + encodeURIComponent(apiKey)
        + '&v=weekly&loading=async&callback='
        + encodeURIComponent(MAP_CALLBACK_NAME);
      script.onload = function () {
        resolveMaps();
      };
      script.onerror = function (error) {
        if (!resolved) reject(error);
      };
      document.head.appendChild(script);
    });

    return mapsPromise;
  }

  function setPlaceholder(mapEl, textValue) {
    var placeholderText = mapEl.querySelector('.karst-sl__map-placeholder p');
    if (placeholderText) placeholderText.textContent = textValue;
  }

  function encodeMarker(svg) {
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }

  function normalizeWebsite(url) {
    var value = String(url || '').trim();
    if (!value) return '';
    if (/^https?:\/\//i.test(value)) return value;
    return 'https://' + value;
  }

  function displayWebsite(url) {
    return String(url || '')
      .replace(/^https?:\/\//i, '')
      .split('/')[0];
  }

  function text(node) {
    return node ? node.textContent.trim() : '';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[char];
    });
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  function debounce(fn, wait) {
    var timer = null;
    return function () {
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  window.KarstStoreLocator = {
    initAll: initAll,
    version: '1.0.0',
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    Array.prototype.forEach.call(event.target.querySelectorAll('.karst-sl'), function (section) {
      if (section.__karstStoreLocator && typeof section.__karstStoreLocator.destroy === 'function') {
        section.__karstStoreLocator.destroy();
      }
    });
  });
})();
